import actions from "./actions";
import mutations from "./mutation";

export default {
  namespaced: true,
  state: {
    loans: [],
    loanCaps: [],
    modelType: "loan",
    loanTypes: [],
    loanRequests: [],
    loanRequestsApproval: [],
    loanRequestsCurrentPage: 1,
    loanRequestsPerPage: 5,
    loanRequestsTotal: [],
    loanRequestsApprovalCurrentPage: 1,
    loanRequestsApprovalPerPage: 5,
    loanRequestsApprovalTotal: [],
    loanCapsTotal: null,
    loanTypesTotal: null,
    tableLoading: false,
    currentPage: 1,
    perPage: 5,
    searchQuery: "",
  },
  actions,
  mutations,
};
